// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unit-block {
  width: 210px;
  margin-bottom: 30px;
}
.unit-block .unit-in-house-title {
  font-size: 14px;
  color: #7f56d9;
  background-color: #f9f5ff;
  border-radius: 22px;
  padding: 4px 8px;
  display: inline-block;
  margin: auto;
}
.unit-block .unit-title {
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
}
.unit-block .unit-table .table-wrapper {
  border: 1px solid #98a2b3;
  border-radius: 0;
  box-shadow: none !important;
}
.unit-block .unit-table .tr.is-first-room-bed:not(:first-child) .td {
  border-top: 1px solid #98a2b3;
}
.unit-block .unit-table .tr .td {
  font-size: 14px;
  color: #101828;
  padding: 2px 5px;
  font-weight: 500;
}
.unit-block .unit-table .tr .td.room-col {
  max-width: 36px;
  width: 36px;
  min-width: 36px;
  white-space: nowrap;
  text-align: center;
  overflow: hidden;
}
.unit-block .unit-table .tr .td.bed-col {
  max-width: 20px;
  width: 20px;
  min-width: 20px;
  word-wrap: break-word;
  font-weight: 400;
  color: #667085;
  text-align: center;
}
.unit-block .unit-table .tr .td.resident-col {
  width: 110px;
  max-width: 110px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.unit-block .unit-table .tr .td.code-col {
  width: 35px;
  max-width: 35px;
  min-width: 35px;
}
.unit-block .unit-table .tr .td.code-col .code-input {
  width: 100%;
  min-width: 30px;
  width: 30px;
  border: none;
  background-color: transparent;
  font-weight: 400;
  color: #101828;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/bedboard/components/UnitTable/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAII;EACE,yBAAA;EACA,gBAAA;EACA,2BAAA;AAFN;AAOQ;EACE,6BAAA;AALV;AASM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAPR;AASQ;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAPV;AAUQ;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AARV;AAWQ;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AATV;AAYQ;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAVV;AAYU;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAVZ","sourcesContent":[".unit-block {\n  width: 210px;\n  margin-bottom: 30px;\n\n  .unit-in-house-title {\n    font-size: 14px;\n    color: #7f56d9;\n    background-color: #f9f5ff;\n    border-radius: 22px;\n    padding: 4px 8px;\n    display: inline-block;\n    margin: auto;\n  }\n\n  .unit-title {\n    font-size: 16px;\n    font-weight: 700;\n    margin-top: 10px;\n  }\n\n  .unit-table {\n    .table-wrapper {\n      border: 1px solid #98a2b3;\n      border-radius: 0;\n      box-shadow: none !important;\n    }\n\n    .tr {\n      &.is-first-room-bed:not(:first-child) {\n        .td {\n          border-top: 1px solid #98a2b3;\n        }\n      }\n\n      .td {\n        font-size: 14px;\n        color: #101828;\n        padding: 2px 5px;\n        font-weight: 500;\n\n        &.room-col {\n          max-width: 36px;\n          width: 36px;\n          min-width: 36px;\n          white-space: nowrap;\n          text-align: center;\n          overflow: hidden;\n        }\n\n        &.bed-col {\n          max-width: 20px;\n          width: 20px;\n          min-width: 20px;\n          word-wrap: break-word;\n          font-weight: 400;\n          color: #667085;\n          text-align: center;\n        }\n\n        &.resident-col {\n          width: 110px;\n          max-width: 110px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n\n        &.code-col {\n          width: 35px;\n          max-width: 35px;\n          min-width: 35px;\n\n          .code-input {\n            width: 100%;\n            min-width: 30px;\n            width: 30px;\n            border: none;\n            background-color: transparent;\n            font-weight: 400;\n            color: #101828;\n            font-size: 16px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
